import { useMapStoreStateToClientState } from './useMapStoreStateToClientState';
import type { Store } from '@/stores';

export default function usePageLayout(store: Store) {
  return useMapStoreStateToClientState(store, (store) => ({
    configStore: store.appStore.config,
    userStore: store.appStore.user,
    currencyStore: store.appStore.currency,
    currencyList: store.appStore.currency.currenciesList,
    loginStore: store.myAccountStore.loginPage.loginStore,
    registerStore: store.myAccountStore.registerPage.registerStore,
    countryStore: store.appStore.flightsPaxPage.country,
  }));
}
